<template>
    <div class="container">
        <div class="space-50"></div>
        <div class="row justify-content-center">
            <div class="text-center">
                    <h2><strong>Comercios afiliados</strong></h2>
                    <p>Cada comercio otorga y valida sus propios puntos</p>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="content-image">
                <carousel v-bind:autoplay="true" v-bind:loop="true">
                    <slide>
                        <img class="img-moyo" src="../../assets/assets_loyalty/logo.jpg">
                        <img class="img-duartee" src="../../assets/assets_loyalty/assets-15.png">
                    </slide>
                    <slide>
                        <img class="img-moyo" src="../../assets/assets_loyalty/Comex-logo.jpg">
                        <img class="img-duartee" src="../../assets/assets_loyalty/Chevrolet-logo.jpg">
                    </slide>
                    <slide>
                        <img class="img-moyo" src="../../assets/assets_loyalty/duartee-co-logo.jpg">
                        <img class="img-duartee" src="../../assets/assets_loyalty/Las-Canastas.jpg">
                    </slide>
                    <slide>
                        <img class="img-moyo" src="../../assets/assets_loyalty/Hotel-El-Dorado.jpg">
                        <img class="img-duartee" src="../../assets/assets_loyalty/Camasha-logo.jpg">
                    </slide>
                </carousel>
            </div>
            <div class="content-image-responsive">
                <carousel v-bind:autoplay="true" v-bind:loop="true">
                    <slide>
                      <img class="img-moyo" src="../../assets/assets_loyalty/logo.jpg">
                    </slide>
                    <slide>
                       <img class="img-duartee" src="../../assets/assets_loyalty/assets-15.png">
                    </slide>
                    <slide>
                      <img class="img-moyo" src="../../assets/assets_loyalty/Comex-logo.jpg">
                    </slide>
                    <slide>
                      <img class="img-duartee" src="../../assets/assets_loyalty/Chevrolet-logo.jpg">
                    </slide>
                    <slide>
                      <img class="img-moyo" src="../../assets/assets_loyalty/duartee-co-logo.jpg">
                    </slide>
                    <slide>
                      <img class="img-duartee" src="../../assets/assets_loyalty/Las-Canastas.jpg">
                    </slide>
                    <slide>
                      <img class="img-moyo" src="../../assets/assets_loyalty/Hotel-El-Dorado.jpg">
                    </slide>
                    <slide>
                      <img class="img-duartee" src="../../assets/assets_loyalty/Camasha-logo.jpg">
                    </slide>
                </carousel>
            </div>
        </div>
    </div>
</template>
<script>
import { Card, FormGroupInput, Button } from '@/components';
import {Carousel, Slide} from 'vue-carousel';

export default {
  components: {
    'carousel': Carousel,
    'slide': Slide,
    Card,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  }
};
</script>
<style>
.img-moyo{
    width: 150px;
    margin: 30px;
}
.img-duartee{
    width: 150px;
    margin: 30px;
}
.img-camasha{
    width: 150px;
    margin: 30px;
}
.img-porrua{
    width: 150px;
    margin: 30px;
}
.VueCarousel-slide {
  width: 200px;
  height:200px;
  color:#FFF;
  display: flex;
  align-items: center;
  justify-content: center;
  border-right:1px solid #FFF;
  box-sizing:border-box;
  font-size:12px;
  text-align:center;
}

.content-image-responsive{
  display: none;
}

@media screen and (min-width: 321px) and (max-width: 768px) { 
  .content-image{
    display: none;
  }
  .content-image-responsive{
    display: block;
  }
  .VueCarousel-slide {
    width: 100%;
    height:200px;
    color:#FFF;
    display: flex;
    align-items: center;
    justify-content: center;
    border-right:1px solid #FFF;
    box-sizing:border-box;
    font-size:12px;
    text-align:center;
    }
  .img-moyo{
    width: 100%;
    margin: 10px;
  }
  .img-duartee{
      width: 100%;
      margin: 10px;
  }
  .img-camasha{
      width: 100%;
      margin: 10px;
  }
  .img-porrua{
      width: 100%;
      margin: 10px;
  }
}
</style>
